import { Key } from '@phosphor-icons/react';
import { Button, PinPad, Text } from '@shh/ui';
import { useState } from 'react';
import { FamilyModeInfo } from '../../components/FamilyModeInfo';
import { PairingPanel } from '../../components/PairingPanel';
import { changeParentPin } from '../../data/api';
import { useFamily } from '../../data/family';
import { settingsText } from '../../i18n/settings';
import { DeviceList } from './DeviceList';

/** Settings → Geräte & PIN: pair the wall tablet with a 6-digit code, change the parent PIN. */
export function DeviceSettings() {
  const f = useFamily();
  // "zuletzt aktiv" is counted from opening the page – good enough for days
  const [opened] = useState(() => Date.now());
  const [pinStep, setPinStep] = useState<'idle' | 'new' | 'repeat' | 'done'>('idle');
  const [firstPin, setFirstPin] = useState('');
  const [pinError, setPinError] = useState<string>();

  return (
    <div className="flex flex-col gap-gap-lg">
      <section className="flex flex-col gap-gap-sm" aria-label={settingsText.wall}>
        <FamilyModeInfo />
        {f.devices.length > 0 && <DeviceList devices={f.devices} now={opened} />}
        <PairingPanel />
      </section>

      <section className="flex flex-col gap-gap-sm" aria-label={settingsText.pin}>
        <Text weight="semibold">{settingsText.pin}</Text>
        <Text size="sm" tone="secondary">
          {settingsText.pinHint}
        </Text>
        {pinStep === 'idle' || pinStep === 'done' ? (
          <div className="flex items-center gap-gap-md">
            <Button variant="secondary" icon={Key} onPress={() => setPinStep('new')}>
              {settingsText.changePin}
            </Button>
            {pinStep === 'done' && (
              <span role="status" className="text-sm font-semibold text-feedback-success">
                {settingsText.pinSaved}
              </span>
            )}
          </div>
        ) : (
          <div className="flex flex-col items-center gap-gap-sm">
            <Text weight="semibold">
              {pinStep === 'new' ? settingsText.newPin4 : settingsText.repeatPin}
            </Text>
            <PinPad
              key={pinStep}
              length={4}
              label={pinStep === 'new' ? settingsText.newPin : settingsText.pinAgain}
              error={pinError}
              onComplete={(pin) => {
                if (pinStep === 'new') {
                  setFirstPin(pin);
                  setPinError(undefined);
                  setPinStep('repeat');
                  return true;
                }
                if (pin !== firstPin) {
                  setPinError(settingsText.pinsDiffer);
                  setPinStep('new');
                  return false;
                }
                void changeParentPin(pin).then(() => setPinStep('done'));
                return true;
              }}
            />
            <Button variant="quiet" onPress={() => setPinStep('idle')}>
              {settingsText.cancel}
            </Button>
          </div>
        )}
      </section>
    </div>
  );
}
